import { useFlags } from "launchdarkly-react-client-sdk";
import { lazy, Suspense } from "react";
import OldQuincy from "./OldQuincy";

const QuincySwitch: React.FC<any> = (props) => {
  const { lookAndFeelQuincy } = useFlags();

  if (lookAndFeelQuincy) {
    const Quincy = lazy(() => import("./NewQuincy"));
    return (
      <Suspense fallback={null}>
        <Quincy {...props} />
      </Suspense>
    );
  }
  return <OldQuincy {...props} />;
};

export default QuincySwitch;
